(function ($) {
    "use strict";
    var POTENZA = {};

    /*************************
     Predefined Variables
     *************************/
    var $window = $(window),
        $document = $(document),
        $pieChart = $('.round-chart');
    //Check if function exists
    $.fn.exists = function () {
        return this.length > 0;
    };

    /*************************
     Tooltip
     *************************/
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover()

    /*************************
     NiceScroll
     *************************/
    POTENZA.pniceScroll = function () {
        loadScript(plugin_path + 'nicescroll/jquery.nicescroll.js', function () {
            $(".scrollbar").niceScroll({
                scrollspeed: 150,
                mousescrollstep: 38,
                cursorwidth: 5,
                cursorborder: 0,
                cursorcolor: 'rgba(0,0,0,0.1)',
                autohidemode: true,
                zindex: 9,
                horizrailenabled: false,
                cursorborderradius: 0,
            });

            // menu scrollbar
            $('.side-menu .collapse').on('shown.bs.collapse', function () {
                $(".side-menu-fixed .scrollbar").getNiceScroll().resize();
            });


            $(".scrollbar-x").niceScroll({
                scrollspeed: 150,
                mousescrollstep: 38,
                cursorwidth: 5,
                cursorborder: 0,
                cursorcolor: 'rgba(0,0,0,0.1)',
                autohidemode: true,
                zindex: 9,
                verticalenabled: false,
                cursorborderradius: 0,
            });
        });
    }


    /****************************************************
     pieChart
     ****************************************************/
    POTENZA.pieChart = function () {
        if ($pieChart.exists()) {
            loadScript(plugin_path + 'easy-pie-chart/easy-pie-chart.js', function () {
                $pieChart.each(function () {
                    var $elem = $(this),
                        pieChartSize = $elem.attr('data-size') || "160",
                        pieChartAnimate = $elem.attr('data-animate') || "2000",
                        pieChartWidth = $elem.attr('data-width') || "6",
                        pieChartColor = $elem.attr('data-color') || "#84ba3f",
                        pieChartTrackColor = $elem.attr('data-trackcolor') || "rgba(0,0,0,0.10)";
                    $elem.find('span, i').css({
                        'width': pieChartSize + 'px',
                        'height': pieChartSize + 'px',
                        'line-height': pieChartSize + 'px'
                    });
                    $elem.appear(function () {
                        $elem.easyPieChart({
                            size: Number(pieChartSize),
                            animate: Number(pieChartAnimate),
                            trackColor: pieChartTrackColor,
                            lineWidth: Number(pieChartWidth),
                            barColor: pieChartColor,
                            scaleColor: false,
                            lineCap: 'square',
                            onStep: function (from, to, percent) {
                                $elem.find('span.percent').text(Math.round(percent));
                            }
                        });
                    });
                });
            });
        }
    }


    /*************************
     DataTable
     *************************/
    POTENZA.datatables = function () {
        if ($('#datatable').exists()) {
            let languageTemplate = 'datatablesLanguage' + (window.locale).toUpperCase();
            $('#datatable').DataTable({
                retrieve: true,
                language: window[languageTemplate],
                order: []
            });
        }
    };


    /*************************
     Search
     *************************/
    POTENZA.searchbox = function () {
        if (jQuery('.search').exists()) {
            jQuery('.search-btn').on("click", function () {
                jQuery('.search').toggleClass("search-open");
                return false;
            });
            jQuery("html, body").on('click', function (e) {
                if (!jQuery(e.target).hasClass("not-click")) {

                    jQuery('.search').removeClass("search-open");
                }
            });
        }
    }

    /*************************
     Sidebarnav
     *************************/
    POTENZA.Sidebarnav = function () {
        /*Sidebar Navigation*/
        $(document).on('click', '#button-toggle', function (e) {
            $("li > ul").collapse('hide');
            return false;
        });
        $(document).on('click', '#button-toggle', function (e) {
            $('#wrapper').toggleClass('slide-menu');
            return false;
        });

        $(document).on("mouseenter mouseleave", ".wrapper > .side-menu-fixed", function (e) {
            if (e.type == "mouseenter") {
                $wrapper.addClass("sidebar-hover");
            } else {
                $wrapper.removeClass("sidebar-hover");
            }
            return false;
        });
        $(document).on("mouseenter mouseleave", ".wrapper > .side-menu-fixed", function (e) {
            if (e.type == "mouseenter") {
                $wrapper.addClass("sidebar-hover");
            } else {
                $wrapper.removeClass("sidebar-hover");
            }
            return false;
        });

        $(document).on("mouseenter mouseleave", ".wrapper > .setting-panel", function (e) {
            if (e.type == "mouseenter") {
                $wrapper.addClass("no-transition");
            } else {
                $wrapper.removeClass("no-transition");
            }
            return false;
        });
    }

    /*************************
     Fullscreenwindow
     *************************/

    POTENZA.Fullscreenwindow = function () {
        if ($('#btnFullscreen').exists()) {
            function toggleFullscreen(elem) {
                elem = elem || document.documentElement;
                if (!document.fullscreenElement && !document.mozFullScreenElement &&
                    !document.webkitFullscreenElement && !document.msFullscreenElement) {
                    if (elem.requestFullscreen) {
                        elem.requestFullscreen();
                    } else if (elem.msRequestFullscreen) {
                        elem.msRequestFullscreen();
                    } else if (elem.mozRequestFullScreen) {
                        elem.mozRequestFullScreen();
                    } else if (elem.webkitRequestFullscreen) {
                        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                    }
                } else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                }
            }

            document.getElementById('btnFullscreen').addEventListener('click', function () {
                toggleFullscreen();
            });
        }
    }

    var qm_typen = {
        raum_menge: "1"
    }

    var labels = {
        next: $('#translationNext').val(),
        previous: $('#translationBack').val(),
        finish: $('#translationSave').val(),
    };

    POTENZA.wizardformNew = function () {
        if ($('#startExaminationV2').exists()) {

            $('#startExaminationV2').steps({
                headerTag: "h3",
                bodyTag: "section",
                labels: labels,
                transitionEffect: "fade",
                autoFocus: true,
                onStepChanging: function (event, currentIndex, newIndex) {
                    if (newIndex <= currentIndex)
                        return true;

                    if (currentIndex === 0) {
                        if (!$('#customer_id').val()) {
                            toastr.warning($('#translationCustomer').val());
                            return false;
                        }
                        if (!$('#name').val()) {
                            toastr.warning($('#translationName').val());
                            return false;
                        }
                    }

                    if (currentIndex === 1) {
                        if (!$('#check_conf_id').val()) {
                            toastr.warning($('#translationCheck').val());
                            return false;
                        }
                    }

                    if (currentIndex === 2) {
                        if (!$('#bezug_id').val()) {
                            toastr.warning($('#translationTyp').val());
                            return false;
                        }
                    }

                    if (currentIndex === 3) {
                        if ($('#rooms').val() !== undefined) {
                            if (!$('#rooms').val() || $('#rooms').val().length === 0) {
                                toastr.warning($('#translationRoom').val());
                                return false;
                            }
                        }
                    }

                    return currentIndex + 1;
                },
                onFinished: function (event, currentIndex) {
                    var form = $('#auswertFormV2');

                    form.submit();
                }
            });
        }
        $('#loadingIcon').hide();
        $('#startExaminationV2').show();
    }

    POTENZA.wizardformIntern = function () {
        let internForm = $('#auswertungIntern');
        if (internForm.exists()) {

            internForm.steps({
                headerTag: "h3",
                labels: labels,
                bodyTag: "section",
                transitionEffect: "fade",
                autoFocus: true,
                onStepChanging: function (event, currentIndex, newIndex) {
                    if (newIndex <= currentIndex)
                        return true;

                    if (currentIndex === 0) {
                        if (!$('#customer_id').val()) {
                            toastr.warning($('#translationCustomer').val());
                            return false;
                        }
                        if (!$('#check_conf_id').val()) {
                            toastr.warning($('#translationCheck').val());
                            return false;
                        }
                        if (!$('#name').val()) {
                            toastr.warning($('#translationName').val());
                            return false;
                        }
                    }

                    if (currentIndex === 1) {
                        if (!$('#expired_at').val()) {
                            toastr.warning($('#translationValid').val());
                            return false;
                        }
                    }

                    return currentIndex + 1;
                },
                onFinished: function () {
                    let form = $('#internForm');

                    form.submit();
                }
            });
        }
        $('#loadingIcon').hide();
        internForm.show();
    }

    /*************************
     Dynamic active menu
     *************************/

    POTENZA.navactivation = function () {
        var path = window.location.pathname.split("/").pop();
        var target = $('.side-menu-fixed .navbar-nav a[href="' + path + '"]');
        target.parent().addClass('active');
        $('.side-menu-fixed .navbar-nav li.active').parents('li').addClass('active');
    }

    /****************************************************
     javascript
     ****************************************************/
    var _arr = {};

    function loadScript(scriptName, callback) {
        if (!_arr[scriptName]) {
            _arr[scriptName] = true;
            var body = document.getElementsByTagName('body')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = scriptName;
            // then bind the event to the callback function
            // there are several events for cross browser compatibility
            // script.onreadystatechange = callback;
            script.onload = callback;
            // fire the loading
            body.appendChild(script);
        } else if (callback) {
            callback();
        }
    }

    /****************************************************
     POTENZA Window load and functions
     ****************************************************/
    //Window load functions
    $window.on("load", function () {
        POTENZA.datatables();
        POTENZA.pieChart();
    });
    //Document ready functions
    $document.ready(function () {
            POTENZA.wizardformNew(),
            POTENZA.wizardformIntern(),
            POTENZA.pniceScroll(),
            POTENZA.searchbox(),
            POTENZA.Sidebarnav(),
            POTENZA.navactivation(),
            POTENZA.Fullscreenwindow();
    });
})(jQuery);


